// register vue composition api globally
import '@/styles/tailwind.css'
import 'primeflex/primeflex.min.css'
import {ViteSSG} from 'vite-ssg'
import generatedRoutes from 'virtual:generated-pages'
import {setupLayouts} from 'virtual:generated-layouts'
import App from './App.vue'
import type {UserModule} from '@/types'
import {getAlternativesPaths, getComparePaths} from '@/data/viewerCompetitors'

const routes = setupLayouts(generatedRoutes)

if (typeof window !== 'undefined') {
    window.addEventListener('vite:preloadError', (event) => {
        event.preventDefault()
        window.location.reload()
    })
}

export const includedRoutes = (paths: string[]) => [
    ...paths.filter((path) => !path.includes(':') && path !== '/:all(.*)*' && path !== '/404'),
    ...getComparePaths(),
    ...getAlternativesPaths(),
]

let loaded = false

export const createApp = ViteSSG(
    App,
    {routes},
    (ctx) => {
        ctx.router.isReady().then(() => {
            if (loaded) return;
            loaded = true;
            Object.values(import.meta.glob<{ install: UserModule }>('./modules/*.ts', {eager: true}))
                .forEach(i => i.install?.(ctx))
        });
    },
)
